import React from "react";
import "./LoadingText.scss";

export const LoadingText = () => <div className="loading-text" />;
